import EmerestAndRoyal from "./EmerestAndRoyal";
import ParksNyc from "./ParksNyc";
import SnowInterview from "./SnowInterview";
import TuAmigo from "./TuAmigo";
import WalksOfLight from "./WalksOfLight";
import WhatIf from "./WhatIf";

export function Portfolio() {
  return (
    <div>
      <ParksNyc />
      <WalksOfLight />
      <SnowInterview />
      <WhatIf />
      <EmerestAndRoyal />
      <TuAmigo />
    </div>
  );
}
